'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        type: '',
        text: '',
        tabIndex: '',
        disabled: { type: Boolean, default: false },
        idTag: { type: String, default: '' }
    },
    data: function data() {
        return {
            classes: ''
        };
    },
    computed: {
        classes: function classes() {
            return this.type && this.type.length ? 'btn--' + this.type : '';
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "<button :id=idTag class=\"btn {{ classes }}\" :tabindex=tabIndex :disabled=disabled>{{ text }}</button>"
